<div class="alert alert-warning" role="alert" *ngIf="!isInstitutionConfigured">
    {{ 'CONFIGURE.NOT_CONFIGURED_CONTACT_INSTITUTION_ADMIN.WARD' | translate }}
  </div>

  
<form class="hygiene-check-form" [formGroup]="hygieneCheckForm" (ngSubmit)="submitForm()" *ngIf="isInstitutionConfigured">
    <div class="dropdown dropdown-large dropdown-floating mb-24">
        <div data-toggle="dropdown" aria-expanded="false" class="cursor">
            <input type="text" class="btn input-dropdown" (click)="onClickWardHandler($event)"
                [placeholder]="'CHECK.CHOOSE_FIELD_ACTIVITY' | translate" formControlName="ward" readonly />
            <span class="label-dropdown">{{ 'CHECK.CHOOSE_FIELD_ACTIVITY' | translate }}</span>
            <img src="assets/icons/arrowDropdownOutlined.svg" />
        </div>

        <ul class="dropdown-menu">
            <li *ngFor="let item of wards" (click)="onChangeSelectedItem(item)">
                <span>{{ item.wardName.toUpperCase() }} </span>
            </li>
        </ul>
    </div>

    <label class="input-floating input-floating-disabled mb-4 department-label">
        <input type="hidden" formControlName="department" class="form-input" [placeholder]="'CHECK.DEPARTMENT' | translate">
        <span>{{ 'CHECK.DEPARTMENT' | translate }}</span>
        <p class="department-name">{{ isInstitutionConfigured ? getDepartmentName() : '' }}</p>
    </label>

    <label class="input-floating mb-40">
        <input type="text" formControlName="otherParticipants" class="form-input" onkeypress="if (event.keyCode == 13) { event.preventDefault(); return false; }" [placeholder]="'CHECK.OTHER_PARTICIPANTS' | translate">
        <span>{{ 'CHECK.OTHER_PARTICIPANTS' | translate }}</span>
    </label>

    <div class="dropdown dropdown-large dropdown-floating mb-24">
        <div data-toggle="dropdown" aria-expanded="false" class="cursor" [ngClass]="isQuestionnaireDisabled() ? 'disabled' : ''">
            <input type="text" class="btn input-dropdown"
                [placeholder]="'CHECK.CHOOSE_QUESTIONNAIRE' | translate" formControlName="questionnaire" readonly />
            <span class="label-dropdown">{{ 'CHECK.CHOOSE_QUESTIONNAIRE' | translate }}</span>
            <img src="assets/icons/arrowDropdownOutlined.svg" />
        </div>

        <ul class="dropdown-menu">
            <li *ngFor="let item of questionnaires" (click)="onChangeSelectedQuestionnaire(item)">
                <span>{{ item.questionnaireName }}</span>
            </li>
        </ul>
    </div>

    <input type="hidden" formControlName="wardId" />
    <input type="hidden" formControlName="institutionId" />
    <input type="hidden" formControlName="questionnaireId" />

    <button type="submit" class="btn btn-cancel submit-btn"
        [disabled]="hygieneCheckForm.invalid">{{ 'CHECK.NEW_HYGIENE_CHECK' | translate }}</button>
</form>
